import React from 'react';
import { ClipboardListIcon, PersonStandingIcon, PrinterIcon, TrafficConeIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { DigitalMicrocopy } from '../DigitalMicrocopy';
import { heroBenefits } from '../../data/salesContent';
import { OFFER_ANCHOR, PRODUCT_IMAGE, PRODUCT_IMAGE_ALT } from '../../data/product';
const benefitIcons = [PersonStandingIcon, TrafficConeIcon, ClipboardListIcon, PrinterIcon];
const benefitColors = ['bg-pumpkin text-ink', 'bg-plum text-cream', 'bg-lime text-ink', 'bg-cream text-ink'];
export function HeroSection() {
  return <section id="top" className="bg-night" data-id="element-49" data-mp="1ijuytxk94edk">
      <div className="mx-auto max-w-5xl px-5 pb-8 text-center sm:px-8" data-id="element-50" data-mp="1ikmut9hrge4d">
        {/* First screen: hook → mockup → short description → CTA */}
        <div className="flex flex-col items-center gap-3 pb-5 pt-4 sm:gap-4 sm:pt-6" data-id="element-51" data-mp="1dixi7pew3se6">
          <div data-id="element-52" data-mp="19l9epxz4srao">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-lime" data-id="element-53" data-mp="14k3m005h1415">For PE Teachers</p>
            <h1 className="mx-auto mt-2 max-w-4xl font-display text-[34px] font-extrabold leading-[1] tracking-tight text-cream sm:text-6xl lg:text-7xl" data-id="element-54" data-mp="31oe5h5ctf178">
              Your Halloween PE Week Is <span className="text-pumpkin" data-id="element-55" data-mp="36gp6kbjakt1d">Already Planned.</span>
            </h1>
          </div>

          <img src={PRODUCT_IMAGE} alt={PRODUCT_IMAGE_ALT} width={1254} height={1254} className="h-[34svh] w-auto max-w-full object-contain sm:h-[42svh]" loading="eager" decoding="sync" {...{
          fetchpriority: 'high'
        }} data-id="element-56" data-mp="2slmsh14ajxdh" />

          <p className="mx-auto max-w-xl text-[14px] leading-snug text-muted sm:text-base" data-id="element-57" data-mp="3begwj00dm52x">
            25 games, 10 visual stations, 8 complete lesson plans and printables — open it, set up the gym, start
            teaching.
          </p>

          <div className="flex w-full max-w-md flex-col items-center gap-2.5" data-id="element-58" data-mp="1zx7fsl8mtr5b">
            <CtaButton href={OFFER_ANCHOR} data-id="element-59" data-mp="24ywovvcanuqr">Get Halloween PE Ready™ Now</CtaButton>
            <DigitalMicrocopy items={['100% Digital', 'Instant Access', 'Downloadable PDFs']} align="center" data-id="element-60" data-mp="ai6jad2pvjlw" />
          </div>
        </div>

        <ul className="grid grid-cols-2 gap-3 text-left lg:grid-cols-4" aria-label="What's included" data-id="element-61" data-mp="5jc03a0u7t19">
          {heroBenefits.map((b, i) => {
          const Icon = benefitIcons[i];
          return <li key={b.label} className="flex items-center gap-3 rounded-2xl border border-line bg-navy p-3" data-id="element-62" data-mp="3stjrf24kx7lw" data-mpi={i}>
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${benefitColors[i]}`} data-id="element-63" data-mp="3nu6utpnwom64">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-64" data-mp="3dy3qcd5l0bg0" />
                </span>
                <span className="font-display text-sm font-bold leading-tight text-cream" data-id="element-65" data-mp="39ws148qmds8c">
                  {b.value && <span className="block text-2xl font-extrabold leading-none" data-id="element-66" data-mp="1c70jlyytbh0q">{b.value}</span>}
                  {b.label}
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}